var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickReferenceAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_11410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_11410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4.875V11.05V11.025V20.875V4.875ZM7.25 14.625H10.8C10.9167 14.3417 11.0583 14.075 11.225 13.825C11.3917 13.575 11.5833 13.3417 11.8 13.125H7.25V14.625ZM7.25 18.625H10.275C10.225 18.375 10.1917 18.125 10.175 17.875C10.1583 17.625 10.1583 17.375 10.175 17.125H7.25V18.625ZM5.3 22.375C4.8 22.375 4.375 22.2 4.025 21.85C3.675 21.5 3.5 21.075 3.5 20.575V5.175C3.5 4.675 3.675 4.25 4.025 3.9C4.375 3.55 4.8 3.375 5.3 3.375H13.25L18.5 8.625V11.375C18.2667 11.2917 18.025 11.225 17.775 11.175C17.525 11.125 17.2667 11.0833 17 11.05V9.375H12.5V4.875H5.3C5.23333 4.875 5.16667 4.90833 5.1 4.975C5.03333 5.04167 5 5.10833 5 5.175V20.575C5 20.6417 5.03333 20.7083 5.1 20.775C5.16667 20.8417 5.23333 20.875 5.3 20.875H11.2C11.4 21.175 11.621 21.45 11.863 21.7C12.1043 21.95 12.3667 22.175 12.65 22.375H5.3ZM16.5 20.025C17.25 20.025 17.8793 19.7707 18.388 19.262C18.896 18.754 19.15 18.125 19.15 17.375C19.15 16.625 18.896 15.996 18.388 15.488C17.8793 14.9793 17.25 14.725 16.5 14.725C15.75 14.725 15.121 14.9793 14.613 15.488C14.1043 15.996 13.85 16.625 13.85 17.375C13.85 18.125 14.1043 18.754 14.613 19.262C15.121 19.7707 15.75 20.025 16.5 20.025ZM21.6 23.525L18.85 20.775C18.5167 21.025 18.15 21.2123 17.75 21.337C17.35 21.4623 16.9333 21.525 16.5 21.525C15.35 21.525 14.3707 21.121 13.562 20.313C12.754 19.5043 12.35 18.525 12.35 17.375C12.35 16.225 12.754 15.2457 13.562 14.437C14.3707 13.629 15.35 13.225 16.5 13.225C17.65 13.225 18.6293 13.629 19.438 14.437C20.246 15.2457 20.65 16.225 20.65 17.375C20.65 17.8083 20.5877 18.225 20.463 18.625C20.3377 19.025 20.15 19.3917 19.9 19.725L22.65 22.475L21.6 23.525Z",
    fill: "#4F0696"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickReferenceAll);
export default __webpack_public_path__ + "static/media/quick_reference_all.e9f7eddc159c5aee9a98e056308b05f2.svg";
export { ForwardRef as ReactComponent };